<div class="container-fluid">
  <div class="row">
    <div class="herobg">
      <div class="vidcon">
        <div class="videocontainer">
          <div class="anim-cont">
            <div class="replay-button">
              <button type="button" (click)="playYouTubeVideo()">
                WATCH VIDEO
              </button>
            </div>
            <div class="tagline">WHERE EDUCATION<br>MEETS OPPORTUNITY</div>
            <div class="slide-border">
              <ul class="slides">
                <li class="slidelist">
                  <span class="slidetext">Credentials of Value</span>
                </li>
                <li class="slidelist">
                  <span class="slidetext">Individualized Advising</span>
                </li>
                <li class="slidelist">
                  <span class="slidetext">Seamless Transitions</span>
                </li>
                <li class="slidelist">
                  <span class="slidetext">Work-Based Learning</span>
                </li>
              </ul>
            </div>
          </div>
          @if (showYouTube) {
          <iframe class="videoembed" src="https://www.youtube.com/embed/y-ufGpDdQug?autoplay=1&rel=0&controls=0"
            title="Future Ready TN Video" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          } @else {
            <video class="videoembed" autoplay muted playsinline>
              <source src="/FutureReady_Preview_Web_MX_1920.mp4" type="video/mp4" title="Future Ready TN Intro Video">
            </video>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <!-- PAGE SUMMARY -->
    <mat-card class="example-card">
      <mat-card-header>
        <mat-card-title>
          <h1>Postsecondary, Workforce, CTE, and Military Readiness</h1>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>
          The Division of Postsecondary, Workforce, CTE, and Military Readiness is committed to ensuring all students
          graduate high school prepared for success. By prioritizing four key pillars—Credentials of Value, Seamless
          Transitions, Individualized Advising, and Work-Based Learning— students will be equipped with the knowledge,
          skills, and experiences needed to thrive in an evolving economy. Through aligned credentials, clear pathways
          to postsecondary education, personalized advising, and hands-on career experiences, the high school experience
          is being transformed to ensure every student can pursue a meaningful and rewarding future. The goals and
          programs associated with each of these pillars not only strengthen workforce readiness but also support
          Tennessee’s economic growth by bridging education and industry needs. Explore each pillar below to learn how
          the Division of Postsecondary, Workforce, CTE, and Military Readiness is building a future-ready Tennessee.
        </p>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="row">
    <!-- PILLARS -->
    <div class="flex-container">
      <a class="outer-pillar-div-one card-link" href="/pillar-1">
        <img src="CredentialsofValue.png" class="card-img-top" alt="">
        <div class="inner-pillar">
          <h2>Credentials of Value</h2>
          <p>Tennessee is dedicated to transforming the high school experience by providing students with access to
            high-quality postsecondary credentials that foster academic success and workforce readiness. By aligning
            secondary and postsecondary credentials with labor market demands, students seamlessly transition into
            in-demand careers.</p>
            <p class="pillar-alignment">Pillar Alignment</p>
            <ul>
              <li class="pillar-bullet">Tennessee Student Industry Credentials of Value</li>
            </ul>
        </div>
      </a>
      <a class="outer-pillar-div-two card-link" href="/pillar-3">
        <img src="IndividualizedAdvising.png" class="card-img-top" alt="">
        <div class="inner-pillar">
          <h2>Individualized Advising</h2>
          <p>Tennessee is establishing a career coach network to improve individualized advising for students. By
            exploring opportunities to increase the capacity of career coaches and advising professionals students will
            be able to make informed decisions regarding their future career options. Career coaches and advising
            professionals will gain the tools needed to increase high-quality advising so students can transition
            successfully after high school graduation.</p>
            <p class="pillar-alignment">Pillar Alignment</p>
            <ul>
              <li class="pillar-bullet">Career & Technical Student Organizations (CTSO)</li>
              <li class="pillar-bullet">Career Coaches</li>
              <li class="pillar-bullet">CTE Career Clusters & Standards</li>
              <li class="pillar-bullet">Graduation Requirements</li>
              <li class="pillar-bullet">Military Readiness</li>
            </ul>
        </div>
      </a>
      <a class="outer-pillar-div-three card-link" href="/pillar-2">
        <img src="SeamlessTransitions.png" class="card-img-top" alt="">
        <div class="inner-pillar">
          <h2>Seamless Transitions</h2>
          <p>Tennessee prioritizes seamless transitions from high school to postsecondary education by aligning K-12 and
            higher education systems. This effort includes highlighting dual enrollment best practices, fostering
            partnerships with higher education stakeholders, and promoting transparency and equity. These initiatives
            ensure clear pathways to postsecondary success, supporting the state’s long-term workforce development
            goals.</p>
            <p class="pillar-alignment">Pillar Alignment</p>
            <ul>
              <li class="pillar-bullet">Accountability and Data Reporting</li>
              <li class="pillar-bullet">Computer Science (CS)</li>
              <li class="pillar-bullet">Early Postsecondary Opportunities (EPSO)</li>
              <li class="pillar-bullet">Innovative School Strategies</li>
              <li class="pillar-bullet">Licensure and Training Attendance Records</li>
              <li class="pillar-bullet">Science, Technology, Engineering, Arts, and Mathematics STE(A)M</li>
            </ul>
        </div>
      </a>
      <a class="outer-pillar-div-four card-link" href="/pillar-4">
        <img src="Work-BasedLearning.png" class="card-img-top" alt="">
        <div class="inner-pillar">
          <h2>Work-Based Learning</h2>
          <p>Tennessee is dedicated to ensuring all students understand how high-quality curriculum and instruction
            allow them to pursue fulfilling careers in high-growth, in-demand, and high-wage industry sectors through
            capstone Work-Based Learning (WBL) experiences. The application of academic and technical knowledge in a
            work setting that involves actual work experience is a critical component of workforce readiness. The
            resources under this Pillar allow all stakeholders to utilize the WBL Framework and offer immersive
            experiences where students leverage their interests and aptitudes to accelerate their careers based on labor
            market needs and available employment opportunities.</p>
            <p class="pillar-alignment">Pillar Alignment</p>
            <ul>
              <li class="pillar-bullet">Work-Based Learning</li>
            </ul>
        </div>
      </a>
    </div>
  </div>

  <!-- NEW QUICK FACTS -->
  <div class="home-insights">
  <div class="row quick-facts-section">
    <div class="flexcontainer">
      <div class="qf-container">
        <div data-module="countup">
          <!-- QUICK FACTS -->
          <div class="colspacing">
            <div class="container wide">
              <div class="row">
                <div class="col-12 col-md-12 light text-center p-3">
                  <h1 class="qf-title">QUICK FACTS</h1>
                  <div class="colored_hr col-12 mx-auto d-block"></div>
                  <div class="stats">
                    <div class="stat">
                      <div class="stat-figure">
                        <div class="value">
                          <span class="text-reverse" [countUp]="industryCredentials" [countUpOptions]="indCred">0</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix quick-facts">
                    <img src="Credentials_01_white-t.png" alt="">
                    <p class="qfclearfix">In 2024-25, 77,455 industry credentials were earned by secondary students
                      statewide.</p>
                  </div>

                  <div class="colored_hr col-12 mx-auto d-block"></div>
                  <div class="stats">
                    <div class="stat">
                      <div class="stat-figure">
                        <div class="value">
                          <span class="text-reverse" [countUp]="studentsEpso" [countUpOptions]="stuEpso">0</span>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix quick-facts">
                      <img src="EPSO_02_white-t.png" alt="">
                      <p class="qfclearfix">Students in EPSOs are up to 88% more likely to pursue postsecondary
                        education after high school graduation.</p>
                    </div>

                    <div class="colored_hr col-12 mx-auto d-block"></div>
                    <div class="stats">
                      <div class="stat">
                        <div class="stat-figure">
                          <div class="value">
                            <span class="text-reverse" [countUp]="personalizedAdvising"
                              [countUpOptions]="persAdv">0</span>
                          </div>
                        </div>
                      </div>
                      <div class="clearfix quick-facts">
                        <img src="PersonalizedAdvising_03_white-t.png" alt="">
                        <p class="qfclearfix">Students who receive personalized advising are 2x more likely to develop a
                          clear postsecondary plan.</p>
                      </div>

                      <div class="colored_hr col-12 mx-auto d-block"></div>
                      <div class="stats">
                        <div class="stat">
                          <div class="stat-figure">
                            <div class="value">
                              <span class="text-reverse" [countUp]="wblStudents" [countUpOptions]="wblStu">0</span>
                            </div>
                          </div>
                        </div>
                        <div class="clearfix quick-facts">
                          <img src="quick-facts-4-t.png" alt="">
                          <p class="qfclearfix">WBL students are nearly 25% more likely to enroll in postsecondary than
                            non WBL students seamlessly after high school.</p>
                        </div>

                        <div class="colored_hr col-12 mx-auto d-block"></div>
                        <div class="stats">
                          <div class="stat">
                            <div class="stat-figure">
                              <div class="value">
                                <span class="text-reverse" [countUp]="moreAverage" [countUpOptions]="morAvg">0</span>
                              </div>
                            </div>
                          </div>
                          <div class="clearfix quick-facts">
                            <img src="dollar-signs.png" alt="">
                            <p class="qfclearfix">WBL students earn nearly $4,200 more on average per year without a
                              postsecondary degree than non-WBL students without a postsecondary degree eight years
                              after high school graduation.</p>
                          </div>
                          <div class="colored_hr col-12 mx-auto d-block"></div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
    <!-- Original FROM OUR STUDENTS carousel retained for reference.
    <div class="row testimonials-section">
            <div class="image-container">
              <h2 class="carousel-header-from-students">FROM OUR STUDENTS...</h2>
              <div role="region" id="carouselExampleDark" class="carousel carousel-dark slide" data-bs-ride="carousel"
                aria-roledescription="Carousel" aria-label="Student Testimonials">
                <div class="carousel-indicators">
                  <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" class="active"
                    aria-current="true" aria-label="Slide 1" data-name="1"></button>
                  <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1"
                    aria-label="Slide 2"></button>
                  <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2"
                    aria-label="Slide 3"></button>
                  <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="3"
                    aria-label="Slide 4"></button>
                  <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="4"
                    aria-label="Slide 5"></button>
                </div>
                <div class="carousel-inner">
                  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark"
                    data-bs-slide="prev" aria-label="Previous Slide">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>

                  <div class="carousel-item active maroon" data-bs-interval="4000">
                    <div class="carousel-caption d-block light">
                      <div class="inner-caro-text">
                        <p>I got certified as a medical assistant, along with getting my
                          BLS certification, which is CPR, before graduating high school. I learned so much that most
                          people don’t get to experience until they’re halfway through college...</p>
                        <h2>NOAH LAND</h2>
                        <p>2025 Graduate<br>Polk County High School<br>Polk County Schools</p>
                      </div>
                    </div>
                  </div>

                  <div class="carousel-item silver" data-bs-interval="4000">
                    <div class="carousel-caption d-block dark">
                      <div class="inner-caro-text">
                        <p>It’s truly incredible—the program of work-based learning in
                          itself, allowing kids to get out into the workforce during the school day, allowing them to
                          search for their future career and get real world experiences...</p>
                        <h2>KATELYN WILLIAMS</h2>
                        <p>2025 Graduate<br>Liberty Creek High School<br>Sumner County Schools</p>
                      </div>
                    </div>
                  </div>

                  <div class="carousel-item blue" data-bs-interval="4000">
                    <div class="carousel-caption d-block light">
                      <div class="inner-caro-text">
                        <p>This could be what I want to do in my future and with my life...
                          The school has helped me towards the goal of going to the airlines and becoming a professional
                          pilot in a lot of different ways...</p>
                        <h2>ANDREW RODABAUGH</h2>
                        <p>Senior<br>Oak Ridge High School<br>Oak Ridge Schools</p>
                      </div>
                    </div>
                  </div>

                  <div class="carousel-item grey" data-bs-interval="4000">
                    <div class="carousel-caption d-block light">
                      <div class="inner-caro-text">
                        <p>I am very grateful to have had the opportunity to earn my Private
                          Pilot's License... This is my senior year at Alcoa High School, and through my aviation
                          program of study, I am now able to participate in a workbased learning internship with Cirrus
                          Aircraft...</p>
                        <h2>LEVI SPIVEY</h2>
                        <p>Senior<br>Alcoa High School<br>Alcoa City Schools</p>
                      </div>
                    </div>
                  </div>

                  <div class="carousel-item maroon" data-bs-interval="40000000">
                    <div class="carousel-caption d-block light">
                      <div class="inner-caro-text-wide">
                        <p><img src="/TDOE_Color.svg" class="portrait-img" />
                          At Nissan, our partnership with high school
                          work-based learning programs is a strategic 
                          investment in the future of advanced manufacturing. By engaging students early, we're
                          able to mentor emerging talent, build real-world technical and professional skills, and inspire the next generation of industry leaders. These experiences not only strengthen our workforce pipeline but also 
                          give students a clear vision of rewarding career paths available right in their own communities.</p>
                        <h2>Dr. Joy Rich</h2>
                        <p>Nissan Group of <br>North America </p>
                        
                      </div>
                    </div>
                  </div>
                </div>

                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleDark"
                  data-bs-slide="next" aria-label="Next Slide">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </button>

              </div>
            </div>
          </div>
    -->

    <!-- FROM OUR STUDENTS scrollable list -->
    <div class="row student-quotes-section">
      <div class="image-container">
        <h2 class="carousel-header-from-students">FROM OUR STUDENTS...</h2>
        <div class="student-quotes-scroll-region" role="region" aria-label="Student testimonials" tabindex="0">
          <ul class="student-quotes-list">
          <li class="student-quote-card">
            <img src="/from-our-students/Joy%20Rich%20Headshot.jpeg" alt="Portrait of Dr. Joy Rich">
            <div>
              <blockquote>At Nissan, our partnership with high school work-based learning programs is a strategic investment in the future of advanced manufacturing. By engaging students early, we're able to mentor emerging talent, build real-world technical and professional skills, and inspire the next generation of industry leaders. These experiences not only strengthen our workforce pipeline but also give students a clear vision of rewarding career paths available right in their own communities.</blockquote>
              <h3>Dr. Joy Rich</h3>
              <p>Nissan Group of North America</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Carri%20Smith%20Headshot.jpg" alt="Portrait of Carri Smith">
            <div>
              <blockquote>Work-based learning is foundational to our mission at Valmont, not only as a strategy to build a skilled and sustainable workforce, but as a commitment to the people and communities we serve. By partnering with local schools, we're able to spark student interest in high-demand careers, provide hands-on experience that builds confidence and purpose, and equip students with skills that support both personal growth and economic mobility. The impact of WBL reaches beyond our walls; it strengthens families, fuels local industry, and shapes the future of our region.</blockquote>
              <h3>Carri Smith</h3>
              <p>Valmont Industries, Inc.</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Jeremy%20Basham%20Headshot.jpg" alt="Portrait of Jeremy Basham">
            <div>
              <blockquote>At Komatsu, our work-based learning programs create a win-win collaboration between industry, education, and the future workforce. These programs provide access to a pipeline of emerging talent with a solid foundation for skill development, while enabling us to work closely with our educational partners to align classroom learning with real-world industry needs. Work-based learning not only adds value to the communities we serve - it also embodies the very essence of Komatsu: creating value together.</blockquote>
              <h3>Jeremy Basham</h3>
              <p>Komatsu</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Chasity%20Fouch%20Headshot.jpg" alt="Portrait of Chasity Fouch">
            <div>
              <blockquote>As the Work-Based Learning Coordinator and mentor, I've seen firsthand how impactful it is for high school students to gain real-world experience in a professional setting. With the guidance of dedicated mentors, students are able to apply what they've learned in the classroom to hands-on tasks while also staying accountable to their academic goals. It's a rewarding experience for the students and equally valuable for the companies that gain fresh perspectives, invest in future talent, and strengthen ties within the community.</blockquote>
              <h3>Chasity Fouch</h3>
              <p>Nissan Decherd Powertrain Assembly Plant</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Jackie%20Headshot%20White%20Gray%20Background.png" alt="Portrait of Jackie Vester">
            <div>
              <blockquote>For many students, CTSOs are where career dreams start to feel real. The coaching, mentorship, networking, and hands-on experiences available through CTSOs help students see their potential and build a path toward their future.</blockquote>
              <h3>Jackie Vester</h3>
              <p>Putnam County Schools</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Takala%20S.%20APAA%20Headshot%2012.25%20APAA%20Highlight.png" alt="Portrait of Takala S.">
            <div>
              <blockquote>After high school, I will go to college and major in Biology because I want to be a Theriogenologist. The APAA course helped me prepare for my next step by allowing me to be more independent for college by letting me complete my work at my own pace.</blockquote>
              <h3>Takala S.</h3>
              <p>Memphis Bluff City High School</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/APAA%20Peyton%20Carroll%20Cook%20Headshot.jpg" alt="Portrait of Peyton Carroll Cook">
            <div>
              <blockquote>AP Access for All gave me opportunities I would not have had otherwise. It allowed me to take challenging courses, push myself academically, and feel confident that I was just as prepared as students anywhere. I am incredibly grateful for the Niswonger Foundation and the doors it opened for me.</blockquote>
              <h3>Peyton Carroll Cook</h3>
              <p>Campbell County High School</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Keith%20Griffith%20Marion%20County%20Picture.jpg" alt="Portrait of Keith Griffith">
            <div>
              <blockquote>I always knew college wasn't for me. When my son was born, I thought my fate was sealed - working long days, hard work with little pay, for the rest of my life. Valmont and this pre-apprenticeship have given me the skills and confidence to not only live in my hometown but also live well and be able to provide for my family. I can still grow and live because of the opportunities given to me through this program.</blockquote>
              <h3>Keith Griffith</h3>
              <p>Marion County Schools</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Tristan%20Fordham%20Marion%20County%20Picture.jpg" alt="Portrait of Tristan Fordham">
            <div>
              <blockquote>I'm leaving with a professional foundation that I'll carry for the rest of my life and career.</blockquote>
              <h3>Tristan Fordham</h3>
              <p>Marion County Schools</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Elizabeth%20Harrison.jpg" alt="Portrait of Elizabeth Harrison">
            <div>
              <blockquote>The pharmacy technician job at Walgreens has been really great. They've been super flexible with my school schedule, and the pay is really good compared to other jobs I could have right now. Getting pharmacy and healthcare experience before I graduate is really valuable.</blockquote>
              <h3>Elizabeth Harrison</h3>
              <p>Bristol Tennessee High School</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Andrew%20Sargent.jpg" alt="Portrait of Andrew Sargent">
            <div>
              <blockquote>I've always wanted to be a doctor, preferably a neurologist. This pathway gets you into healthcare early, and being able to do it while you're still in high school is a really good opportunity.</blockquote>
              <h3>Andrew Sargent</h3>
              <p>Bristol Tennessee High School</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Victoria%20Harman.jpg" alt="Portrait of Victoria Harman">
            <div>
              <blockquote>The most surprising thing I learned was how you interact with patients. There are a lot of guidelines and laws you have to follow for privacy, safety, and everything related to patient care.</blockquote>
              <h3>Victoria Harman</h3>
              <p>Bristol Tennessee High School</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Izabella%20W.%20Headshot%201.26%20APAA%20Highlight.png" alt="Portrait of Izabella W.">
            <div>
              <blockquote>I plan to attend college and pursue a degree in Special Education to help students with disabilities, like my brother. APAA courses are helping to prepare me for what college coursework is like and allowing me to obtain college credits that could help me graduate from college sooner than expected.</blockquote>
              <h3>Izabella W.</h3>
              <p>Perry County High School</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Kulesh_Haille.jpg" alt="Portrait of Haille Kulesh">
            <div>
              <blockquote>I feel I got my bio lab assistant position because of BioSTEM and having my BACE certification. They thought it was very impressive that I had so much experience already. The class and the BACE exam have prepared me for lab settings and classes.</blockquote>
              <h3>Haille Kulesh</h3>
              <p>White House Heritage High School, Robertson County</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Malich_Dominic.jpg" alt="Portrait of Dominic Malich">
            <div>
              <blockquote>I've shadowed some of the dentists and oral surgeons at the hospital next to West Point, and just applied for a couple of internships to shadow various surgeons and doctors at Army hospitals in Texas and New York over the summer. One of the biggest things that has transferred over from BioSTEM to the dental and medical field is maintaining proper aseptic technique. I also got the biology major, which is only given to the top 36 cadets who applied for it and is usually competitive each year. I feel that being able to say that I took BioSTEM and did well enough in it to pass the BACE helped give me an advantage over the other cadets applying for the major. It is definitely a unique opportunity that not a lot of students get a chance to do, and I think it is worth taking every level of BioSTEM offered if you have any interest in science, medicine, or biology.</blockquote>
              <h3>Dominic Malich</h3>
              <p>White House Heritage High School, Robertson County</p>
            </div>
          </li>
          <li class="student-quote-card">
            <img src="/from-our-students/Jayda_Cowan_STEM_quote.jpeg" alt="Portrait of Jayda Cowan">
            <div>
              <blockquote>Being in a STEM school has benefited me in many ways. First, it helped me with advanced learning. Second, it helped me a lot with plants because they talk a lot about how to take care of them. Third, we are a project-based learning community. That helps me because it could benefit me in future jobs, such as becoming a doctor. Fourth, it can help us later in life with other jobs, such as being a cashier, where we take cash and count it. Fifth, we do presentations that also help us with public speaking. We also do school announcements, which help with speaking loudly and clearly. In conclusion, being in a STEM school has benefited me in many ways.</blockquote>
              <h3>Jayda Cowan</h3>
              <p>Hickerson Elementary</p>
            </div>
          </li>
          </ul>
        </div>
      </div>
    </div>

  </div>

  <div class="row row-gallery">
      <app-rotating-gallery />
  </div>
</div>
